//# sourceMappingURL=card.mjs.map
/// <reference types="./card.d.mts" />
import * as $text from "../../ds/ds/typography/text.mjs";
import * as $a from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../sketch/sketch/css.mjs";
import * as $length from "../../sketch/sketch/css/length.mjs";
import { px } from "../../sketch/sketch/css/length.mjs";
import * as $h from "../../sketch_redraw/sketch/redraw/dom/html.mjs";
import { toList, prepend as listPrepend } from "../gleam.mjs";
import * as $common from "../view/common.mjs";

export function card(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($common.card()),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.padding_("9px 12px"),
      $css.max_width(px(400)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function card_custom_width(width, attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($common.card()),
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.padding_("9px 12px"),
      $css.max_width(px(width)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function title(attrs, children) {
  let _pipe = $css.class$(toList([$css.compose($text.md($text.medium))]));
  return $h.div(_pipe, attrs, children);
}

export function body(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.regular)),
      $css.padding_top(px(6)),
      $css.selector(":has(+ .footer)", toList([$css.flex("1")])),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function footer(attrs, children) {
  let class$ = $a.class$("footer");
  let _pipe = $css.class$(toList([$css.padding_top(px(12))]));
  return $h.div(_pipe, listPrepend(class$, attrs), children);
}
